import styled from "@emotion/styled";
import { spin } from "styles/animations";

import { yellow600 } from "../../lib/themes/colors";

// Path data reused by the multi-layer brand marks below, whose gradients are stacked as repeated
// copies of one shape. Deliberately not exported: every export in this file becomes a CustomIconKey,
// and a non-element export would resolve to an icon that fails isValidElement at render.
const geminiStar =
  "M20.616 10.835a14.147 14.147 0 01-4.45-3.001 14.111 14.111 0 01-3.678-6.452.503.503 0 00-.975 0 14.134 14.134 0 01-3.679 6.452 14.155 14.155 0 01-4.45 3.001c-.65.28-1.318.505-2.002.678a.502.502 0 000 .975c.684.172 1.35.397 2.002.677a14.147 14.147 0 014.45 3.001 14.112 14.112 0 013.679 6.453.502.502 0 00.975 0c.172-.685.397-1.351.677-2.003a14.145 14.145 0 013.001-4.45 14.113 14.113 0 016.453-3.678.503.503 0 000-.975 13.245 13.245 0 01-2.003-.678z";

const copilotLeftWing =
  "M15 0H6.252c-2.5 0-4 3.331-5 6.662-1.184 3.947-2.734 9.225 1.75 9.225H6.78c1.13 0 2.12-.753 2.43-1.847.657-2.317 1.809-6.359 2.713-9.436.46-1.563.842-2.906 1.43-3.742A1.97 1.97 0 0115 0";

const copilotRightWing =
  "M9 22h8.749c2.5 0 4-3.332 5-6.663 1.184-3.948 2.734-9.227-1.75-9.227H17.22c-1.129 0-2.12.754-2.43 1.848a1149.2 1149.2 0 01-2.713 9.437c-.46 1.564-.842 2.907-1.43 3.743A1.97 1.97 0 019 22";

export const hubspot = (
  <svg
    height="14"
    viewBox="6.20856283 .64498824 244.26943717 251.24701176"
    width="14"
    xmlns="http://www.w3.org/2000/svg"
  >
    <title>Hubspot.com logo</title>
    <desc>
      An inbound marketing and sales CRM platform designed for small and medium-sized businesses
    </desc>
    <path
      d="m191.385 85.694v-29.506a22.722 22.722 0 0 0 13.101-20.48v-.677c0-12.549-10.173-22.722-22.721-22.722h-.678c-12.549 0-22.722 10.173-22.722 22.722v.677a22.722 22.722 0 0 0 13.101 20.48v29.506a64.342 64.342 0 0 0 -30.594 13.47l-80.922-63.03c.577-2.083.878-4.225.912-6.375a25.6 25.6 0 1 0 -25.633 25.55 25.323 25.323 0 0 0 12.607-3.43l79.685 62.007c-14.65 22.131-14.258 50.974.987 72.7l-24.236 24.243c-1.96-.626-4-.959-6.057-.987-11.607.01-21.01 9.423-21.007 21.03.003 11.606 9.412 21.014 21.018 21.017 11.607.003 21.02-9.4 21.03-21.007a20.747 20.747 0 0 0 -.988-6.056l23.976-23.985c21.423 16.492 50.846 17.913 73.759 3.562 22.912-14.352 34.475-41.446 28.985-67.918-5.49-26.473-26.873-46.734-53.603-50.792m-9.938 97.044a33.17 33.17 0 1 1 0-66.316c17.85.625 32 15.272 32.01 33.134.008 17.86-14.127 32.522-31.977 33.165"
      fill="currentColor"
    />
  </svg>
);

export const salesforce = (
  <svg
    version="1.1"
    height="14"
    width="14"
    viewBox="0 0 273 191"
    xmlns="http://www.w3.org/2000/svg"
  >
    <title>Salesforce.com logo</title>
    <desc>
      An enterprise-focused CRM platform offering advanced sales, customer service, and marketing
      solutions
    </desc>
    <defs>
      <path id="a" d="m0.06 0.5h272v190h-272z" />
    </defs>
    <g fillRule="evenodd">
      <path
        d="m113 21.3c8.78-9.14 21-14.8 34.5-14.8 18 0 33.6 10 42 24.9a58 58 0 0 1 23.7-5.05c32.4 0 58.7 26.5 58.7 59.2s-26.3 59.2-58.7 59.2c-3.96 0-7.82-0.398-11.6-1.15-7.35 13.1-21.4 22-37.4 22a42.7 42.7 0 0 1-18.8-4.32c-7.45 17.5-24.8 29.8-45 29.8-21.1 0-39-13.3-45.9-32a45.1 45.1 0 0 1-9.34 0.972c-25.1 0-45.4-20.6-45.4-45.9 0-17 9.14-31.8 22.7-39.8a52.6 52.6 0 0 1-4.35-21c0-29.2 23.7-52.8 52.9-52.8 17.1 0 32.4 8.15 42 20.8"
        fill="currentColor"
        mask="url(#b)"
      />
    </g>
  </svg>
);

export const google = (
  <svg version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48">
    <title>Google Logo</title>
    <path
      fill="#EA4335"
      d="M24 9.5c3.54 0 6.71 1.22 9.21 3.6l6.85-6.85C35.9 2.38 30.47 0 24 0 14.62 0 6.51 5.38 2.56 13.22l7.98 6.19C12.43 13.72 17.74 9.5 24 9.5z"
    />
    <path
      fill="#4285F4"
      d="M46.98 24.55c0-1.57-.15-3.09-.38-4.55H24v9.02h12.94c-.58 2.96-2.26 5.48-4.78 7.18l7.73 6c4.51-4.18 7.09-10.36 7.09-17.65z"
    />
    <path
      fill="#FBBC05"
      d="M10.53 28.59c-.48-1.45-.76-2.99-.76-4.59s.27-3.14.76-4.59l-7.98-6.19C.92 16.46 0 20.12 0 24c0 3.88.92 7.54 2.56 10.78l7.97-6.19z"
    />
    <path
      fill="#34A853"
      d="M24 48c6.48 0 11.93-2.13 15.89-5.81l-7.73-6c-2.15 1.45-4.92 2.3-8.16 2.3-6.26 0-11.57-4.22-13.47-9.91l-7.98 6.19C6.51 42.62 14.62 48 24 48z"
    />
    <path fill="none" d="M0 0h48v48H0z" />
  </svg>
);

export const microsoft = (
  <svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 21 21">
    <title>Microsoft Logo</title>
    <rect x="1" y="1" width="9" height="9" fill="#f25022" />
    <rect x="1" y="11" width="9" height="9" fill="#00a4ef" />
    <rect x="11" y="1" width="9" height="9" fill="#7fba00" />
    <rect x="11" y="11" width="9" height="9" fill="#ffb900" />
  </svg>
);

export const chatgpt = (
  <svg height="24" width="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <title>ChatGPT logo</title>
    <desc>OpenAI&apos;s AI assistant</desc>
    <path
      fillRule="evenodd"
      fill="currentColor"
      d="M9.205 8.658v-2.26c0-.19.072-.333.238-.428l4.543-2.616c.619-.357 1.356-.523 2.117-.523 2.854 0 4.662 2.212 4.662 4.566 0 .167 0 .357-.024.547l-4.71-2.759a.797.797 0 00-.856 0l-5.97 3.473zm10.609 8.8V12.06c0-.333-.143-.57-.429-.737l-5.97-3.473 1.95-1.118a.433.433 0 01.476 0l4.543 2.617c1.309.76 2.189 2.378 2.189 3.948 0 1.808-1.07 3.473-2.76 4.163zM7.802 12.703l-1.95-1.142c-.167-.095-.239-.238-.239-.428V5.899c0-2.545 1.95-4.472 4.591-4.472 1 0 1.927.333 2.712.928L8.23 5.067c-.285.166-.428.404-.428.737v6.898zM12 15.128l-2.795-1.57v-3.33L12 8.658l2.795 1.57v3.33L12 15.128zm1.796 7.23c-1 0-1.927-.332-2.712-.927l4.686-2.712c.285-.166.428-.404.428-.737v-6.898l1.974 1.142c.167.095.238.238.238.428v5.233c0 2.545-1.974 4.472-4.614 4.472zm-5.637-5.303l-4.544-2.617c-1.308-.761-2.188-2.378-2.188-3.948A4.482 4.482 0 014.21 6.327v5.423c0 .333.143.571.428.738l5.947 3.449-1.95 1.118a.432.432 0 01-.476 0zm-.262 3.9c-2.688 0-4.662-2.021-4.662-4.519 0-.19.024-.38.047-.57l4.686 2.71c.286.167.571.167.856 0l5.97-3.448v2.26c0 .19-.07.333-.237.428l-4.543 2.616c-.619.357-1.356.523-2.117.523zm5.899 2.83a5.947 5.947 0 005.827-4.756C22.287 18.339 24 15.84 24 13.296c0-1.665-.713-3.282-1.998-4.448.119-.5.19-.999.19-1.498 0-3.401-2.759-5.947-5.946-5.947-.642 0-1.26.095-1.88.31A5.962 5.962 0 0010.205 0a5.947 5.947 0 00-5.827 4.757C1.713 5.447 0 7.945 0 10.49c0 1.666.713 3.283 1.998 4.448-.119.5-.19 1-.19 1.499 0 3.401 2.759 5.946 5.946 5.946.642 0 1.26-.095 1.88-.309a5.96 5.96 0 004.162 1.713z"
    />
  </svg>
);

export const claude = (
  <svg height="24" width="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <title>Claude logo</title>
    <desc>Anthropic&apos;s AI assistant</desc>
    <path
      fillRule="nonzero"
      fill="#D97757"
      d="M4.709 15.955l4.72-2.647.08-.23-.08-.128H9.2l-.79-.048-2.698-.073-2.339-.097-2.266-.122-.571-.121L0 11.784l.055-.352.48-.321.686.06 1.52.103 2.278.158 1.652.097 2.449.255h.389l.055-.157-.134-.098-.103-.097-2.358-1.596-2.552-1.688-1.336-.972-.724-.491-.364-.462-.158-1.008.656-.722.881.06.225.061.893.686 1.908 1.476 2.491 1.833.365.304.145-.103.019-.073-.164-.274-1.355-2.446-1.446-2.49-.644-1.032-.17-.619a2.97 2.97 0 01-.104-.729L6.283.134 6.696 0l.996.134.42.364.62 1.414 1.002 2.229 1.555 3.03.456.898.243.832.091.255h.158V9.01l.128-1.706.237-2.095.23-2.695.08-.76.376-.91.747-.492.584.28.48.685-.067.444-.286 1.851-.559 2.903-.364 1.942h.212l.243-.242.985-1.306 1.652-2.064.73-.82.85-.904.547-.431h1.033l.76 1.129-.34 1.166-1.064 1.347-.881 1.142-1.264 1.7-.79 1.36.073.11.188-.02 2.856-.606 1.543-.28 1.841-.315.833.388.091.395-.328.807-1.969.486-2.309.462-3.439.813-.042.03.049.061 1.549.146.662.036h1.622l3.02.225.79.522.474.638-.079.485-1.215.62-1.64-.389-3.829-.91-1.312-.329h-.182v.11l1.093 1.068 2.006 1.81 2.509 2.33.127.578-.322.455-.34-.049-2.205-1.657-.851-.747-1.926-1.62h-.128v.17l.444.649 2.345 3.521.122 1.08-.17.353-.608.213-.668-.122-1.374-1.925-1.415-2.167-1.143-1.943-.14.08-.674 7.254-.316.37-.729.28-.607-.461-.322-.747.322-1.476.389-1.924.315-1.53.286-1.9.17-.632-.012-.042-.14.018-1.434 1.967-2.18 2.945-1.726 1.845-.414.164-.717-.37.067-.662.401-.589 2.388-3.036 1.44-1.882.93-1.086-.006-.158h-.055L4.132 18.56l-1.13.146-.487-.456.061-.746.231-.243 1.908-1.312-.006.006z"
    />
  </svg>
);

export const gemini = (
  <svg height="24" width="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <title>Gemini logo</title>
    <desc>Google&apos;s AI assistant</desc>
    <path d={geminiStar} fill="#3186FF" />
    <path d={geminiStar} fill="url(#stotles-gemini-a)" />
    <path d={geminiStar} fill="url(#stotles-gemini-b)" />
    <path d={geminiStar} fill="url(#stotles-gemini-c)" />
    <defs>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="stotles-gemini-a"
        x1="7"
        x2="11"
        y1="15.5"
        y2="12"
      >
        <stop stopColor="#08B962" />
        <stop offset="1" stopColor="#08B962" stopOpacity="0" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="stotles-gemini-b"
        x1="8"
        x2="11.5"
        y1="5.5"
        y2="11"
      >
        <stop stopColor="#F94543" />
        <stop offset="1" stopColor="#F94543" stopOpacity="0" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="stotles-gemini-c"
        x1="3.5"
        x2="17.5"
        y1="13.5"
        y2="12"
      >
        <stop stopColor="#FABC12" />
        <stop offset=".46" stopColor="#FABC12" stopOpacity="0" />
      </linearGradient>
    </defs>
  </svg>
);

export const microsoft365Copilot = (
  <svg height="24" width="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <title>Microsoft 365 Copilot logo</title>
    <desc>Microsoft&apos;s AI assistant for Microsoft 365</desc>
    <path
      transform="translate(0 1)"
      fill="url(#stotles-copilot-a)"
      d="M17.533 1.829A2.528 2.528 0 0015.11 0h-.737a2.531 2.531 0 00-2.484 2.087l-1.263 6.937.314-1.08a2.528 2.528 0 012.424-1.833h4.284l1.797.706 1.731-.706h-.505a2.528 2.528 0 01-2.423-1.829l-.715-2.453z"
    />
    <path
      transform="translate(0 1)"
      fill="url(#stotles-copilot-b)"
      d="M6.726 20.16A2.528 2.528 0 009.152 22h1.566c1.37 0 2.49-1.1 2.525-2.48l.17-6.69-.357 1.228a2.528 2.528 0 01-2.423 1.83h-4.32l-1.54-.842-1.667.843h.497c1.124 0 2.113.75 2.426 1.84l.697 2.432z"
    />
    <path transform="translate(0 1)" fill="url(#stotles-copilot-c)" d={copilotLeftWing} />
    <path transform="translate(0 1)" fill="url(#stotles-copilot-d)" d={copilotLeftWing} />
    <path transform="translate(0 1)" fill="url(#stotles-copilot-e)" d={copilotRightWing} />
    <path transform="translate(0 1)" fill="url(#stotles-copilot-f)" d={copilotRightWing} />
    <defs>
      <radialGradient
        cx="85.44%"
        cy="100.653%"
        fx="85.44%"
        fy="100.653%"
        gradientTransform="scale(-.8553 -1) rotate(50.927 2.041 -1.946)"
        id="stotles-copilot-a"
        r="105.116%"
      >
        <stop offset="9.6%" stopColor="#00AEFF" />
        <stop offset="77.3%" stopColor="#2253CE" />
        <stop offset="100%" stopColor="#0736C4" />
      </radialGradient>
      <radialGradient
        cx="18.143%"
        cy="32.928%"
        fx="18.143%"
        fy="32.928%"
        gradientTransform="scale(.8897 1) rotate(52.069 .193 .352)"
        id="stotles-copilot-b"
        r="95.612%"
      >
        <stop offset="0%" stopColor="#FFB657" />
        <stop offset="63.4%" stopColor="#FF5F3D" />
        <stop offset="92.3%" stopColor="#C02B3C" />
      </radialGradient>
      <linearGradient id="stotles-copilot-c" x1="39.465%" x2="46.884%" y1="12.117%" y2="103.774%">
        <stop offset="15.6%" stopColor="#0D91E1" />
        <stop offset="48.7%" stopColor="#52B471" />
        <stop offset="65.2%" stopColor="#98BD42" />
        <stop offset="93.7%" stopColor="#FFC800" />
      </linearGradient>
      <linearGradient id="stotles-copilot-d" x1="45.949%" x2="50%" y1="0%" y2="100%">
        <stop offset="0%" stopColor="#3DCBFF" />
        <stop offset="24.7%" stopColor="#0588F7" stopOpacity="0" />
      </linearGradient>
      <radialGradient
        cx="82.987%"
        cy="-9.792%"
        fx="82.987%"
        fy="-9.792%"
        gradientTransform="scale(-1 -.9441) rotate(-70.872 .142 1.17)"
        id="stotles-copilot-e"
        r="140.622%"
      >
        <stop offset="6.6%" stopColor="#8C48FF" />
        <stop offset="50%" stopColor="#F2598A" />
        <stop offset="89.6%" stopColor="#FFB152" />
      </radialGradient>
      <linearGradient id="stotles-copilot-f" x1="83.507%" x2="83.453%" y1="-6.106%" y2="21.131%">
        <stop offset="5.8%" stopColor="#F8ADFA" />
        <stop offset="70.8%" stopColor="#A86EDD" stopOpacity="0" />
      </linearGradient>
    </defs>
  </svg>
);

export const stotles = (
  <svg
    width="800"
    height="800"
    viewBox="0 0 800 800"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <title>Stotles.com logo</title>
    <rect width="800" height="800" rx="168" fill="white" />
    <path
      d="M328.256 400C359.7 385.153 385.153 359.7 400 328.256C414.847 359.7 440.3 385.153 471.744 400C440.3 414.847 414.847 440.3 400 471.744C385.153 440.3 359.7 414.847 328.256 400Z"
      fill="#2569F9"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M142.857 0C63.9593 0 0 63.9593 0 142.857V657.143C0 736.041 63.9593 800 142.857 800H657.143C736.041 800 800 736.041 800 657.143V142.857C800 63.9594 736.041 0 657.143 0H142.857ZM264.286 114.286C324.247 114.286 375.991 149.468 400 200.315C424.009 149.468 475.753 114.286 535.714 114.286C618.557 114.286 685.714 181.443 685.714 264.286C685.714 324.247 650.532 375.991 599.685 400C650.532 424.009 685.714 475.753 685.714 535.714C685.714 618.557 618.557 685.714 535.714 685.714C475.753 685.714 424.009 650.532 400 599.685C375.991 650.532 324.247 685.714 264.286 685.714C181.443 685.714 114.286 618.557 114.286 535.714C114.286 475.753 149.468 424.009 200.315 400C149.468 375.991 114.286 324.247 114.286 264.286C114.286 181.443 181.443 114.286 264.286 114.286Z"
      fill="#2569F9"
    />
  </svg>
);

export const linkedin = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width="16"
    height="16"
    fill="currentColor"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M 5 3 C 3.895 3 3 3.895 3 5 L 3 19 C 3 20.105 3.895 21 5 21 L 19 21 C 20.105 21 21 20.105 21 19 L 21 5 C 21 3.895 20.105 3 19 3 L 5 3 z M 5 5 L 19 5 L 19 19 L 5 19 L 5 5 z M 7.7792969 6.3164062 C 6.9222969 6.3164062 6.4082031 6.8315781 6.4082031 7.5175781 C 6.4082031 8.2035781 6.9223594 8.7167969 7.6933594 8.7167969 C 8.5503594 8.7167969 9.0644531 8.2035781 9.0644531 7.5175781 C 9.0644531 6.8315781 8.5502969 6.3164062 7.7792969 6.3164062 z M 6.4765625 10 L 6.4765625 17 L 9 17 L 9 10 L 6.4765625 10 z M 11.082031 10 L 11.082031 17 L 13.605469 17 L 13.605469 13.173828 C 13.605469 12.034828 14.418109 11.871094 14.662109 11.871094 C 14.906109 11.871094 15.558594 12.115828 15.558594 13.173828 L 15.558594 17 L 18 17 L 18 13.173828 C 18 10.976828 17.023734 10 15.802734 10 C 14.581734 10 13.930469 10.406562 13.605469 10.976562 L 13.605469 10 L 11.082031 10 z"
    />
  </svg>
);

export const okta = (
  <svg xmlns="http://www.w3.org/2000/svg" width="42" height="42" viewBox="0 0 42 42">
    <path
      d="m23.104.358-.862 10.607a10.3 10.3 0 0 0-2.784.04l-.491-5.143a.274.274 0 0 1 .275-.3h.88L19.699.359A.274.274 0 0 1 19.97.06h2.856c.16 0 .285.137.273.298zm-7.208.526a.275.275 0 0 0-.36-.185l-2.684.975a.274.274 0 0 0-.155.373l2.183 4.746-.83.3a.275.275 0 0 0-.155.376l2.224 4.667c.806-.444 1.68-.777 2.603-.988zm-6.59 2.954 6.177 8.678a10.2 10.2 0 0 0-2.105 1.82l-3.694-3.63A.275.275 0 0 1 9.7 10.3l.676-.563-3.678-3.715a.274.274 0 0 1 .02-.403l2.186-1.832a.277.277 0 0 1 .403.051m-5.18 5.024a.28.28 0 0 0-.396.088l-1.428 2.468a.274.274 0 0 0 .12.385l4.731 2.236-.442.76a.274.274 0 0 0 .123.388l4.714 2.149c.342-.875.797-1.69 1.355-2.425zM.64 15.567a.275.275 0 0 1 .34-.218l10.324 2.689c-.266.869-.416 1.79-.437 2.741l-5.17-.413a.274.274 0 0 1-.248-.322l.155-.864-5.211-.488a.275.275 0 0 1-.246-.322l.494-2.805zM.25 22.52a.275.275 0 0 0-.246.322L.5 25.647a.275.275 0 0 0 .34.218l5.066-1.32.152.864c.028.16.188.26.344.217l4.996-1.376a10 10 0 0 1-.524-2.728zm1.65 7.37a.274.274 0 0 1 .12-.385l9.64-4.558a10 10 0 0 0 1.433 2.381l-4.225 2.997a.274.274 0 0 1-.397-.086l-.44-.762-4.306 2.968a.276.276 0 0 1-.395-.088zm11.68-1.999-7.499 7.574a.274.274 0 0 0 .02.403l2.188 1.83c.124.104.309.08.402-.05l3.029-4.26.674.567c.123.104.312.08.404-.054l2.94-4.254a10.3 10.3 0 0 1-2.158-1.756m-1.48 12.16a.274.274 0 0 1-.156-.373l4.447-9.675a10 10 0 0 0 2.63.911l-1.304 5.002a.274.274 0 0 1-.36.188l-.828-.303-1.387 5.035a.275.275 0 0 1-.36.184l-2.685-.973zm7.658-9.019-.86 10.61a.275.275 0 0 0 .273.297h2.855c.16 0 .288-.137.274-.297l-.426-5.204h.881a.274.274 0 0 0 .275-.299l-.49-5.144q-.756.115-1.543.116-.63-.002-1.24-.077zM30.057 2.32a.276.276 0 0 0-.155-.373L27.217.973a.276.276 0 0 0-.36.185L25.47 6.193l-.827-.303a.274.274 0 0 0-.36.188l-1.305 5.002a10 10 0 0 1 2.63.911l4.449-9.673zm5.86 4.216L28.42 14.11a10.2 10.2 0 0 0-2.158-1.758l2.94-4.253a.276.276 0 0 1 .404-.053l.674.566 3.029-4.258a.277.277 0 0 1 .402-.051l2.188 1.83c.124.104.133.29.02.403m4.062 5.96a.273.273 0 0 0 .12-.385l-1.43-2.467a.276.276 0 0 0-.395-.088l-4.306 2.968-.44-.762a.274.274 0 0 0-.397-.086l-4.225 2.997c.58.72 1.066 1.519 1.433 2.38zm1.52 3.861.497 2.805a.275.275 0 0 1-.246.322l-10.624.994a10 10 0 0 0-.524-2.727l4.996-1.375a.275.275 0 0 1 .345.217l.15.864 5.064-1.32c.156-.04.313.06.341.218zm-.48 10.296c.156.04.313-.06.341-.218l.495-2.805a.276.276 0 0 0-.246-.322l-5.211-.487.155-.865a.275.275 0 0 0-.249-.322l-5.169-.413a10 10 0 0 1-.437 2.743l10.324 2.688zm-2.749 6.4a.28.28 0 0 1-.395.088l-8.782-6.048a10 10 0 0 0 1.356-2.425l4.714 2.15a.273.273 0 0 1 .123.388l-.443.76 4.731 2.237a.274.274 0 0 1 .12.385l-1.427 2.467zm-11.753-3.567 6.177 8.68c.093.13.277.154.402.05l2.187-1.831a.274.274 0 0 0 .019-.403l-3.678-3.715.676-.563a.273.273 0 0 0 .016-.405l-3.694-3.629a10.2 10.2 0 0 1-2.105 1.818zm-.053 11.817a.276.276 0 0 1-.36-.185l-2.827-10.263a10 10 0 0 0 2.603-.987l2.223 4.667a.274.274 0 0 1-.155.377l-.83.299 2.184 4.746a.276.276 0 0 1-.156.373l-2.684.975z"
      fill="black"
    />
  </svg>
);

export const onelogin = (
  <svg viewBox="0 0 409 409" xmlns="http://www.w3.org/2000/svg" width="2500" height="2500">
    <circle cx="204.5" cy="204.5" fill="#1f1f1f" r="204.5" />
    <path
      d="M182 140h-26.46a7.55 7.55 0 0 0-7.54 7.54v33.92a7.55 7.55 0 0 0 7.54 7.54H182v85.46a7.55 7.55 0 0 0 7.54 7.54h33.92a7.55 7.55 0 0 0 7.54-7.54V147.54a7.55 7.55 0 0 0-7.54-7.54z"
      fill="#fff"
    />
  </svg>
);

export const keycloak = (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" width="48px" height="48px">
    <path
      fill="#4d4d4d"
      d="M 6.291 13.019 L 12.496 2.253 L 37.485 2.25 L 43.657 13.122 L 43.664 34.871 L 37.486 45.737 L 12.505 45.746 L 6.228 34.872 L 6.291 13.019 Z"
    />
    <path
      fill="#ededed"
      d="M 6.229 34.869 L 17.491 34.869 L 11.305 23.913 L 16.336 13.021 L 6.292 13.019 L 0 24.001"
    />
    <path
      fill="#e0e0e0"
      d="M 20.906 34.869 L 29.138 34.869 L 36.417 24.205 L 29.265 13.123 L 19.582 13.123 L 13.749 23.832 L 20.906 34.869 Z"
    />
    <path fill="#acacac" d="M 0 24 L 6.229 34.872 L 17.492 34.872 L 11.374 24.037 L 0 24 Z" />
    <path
      fill="#9e9e9e"
      d="M 13.867 24.002 L 20.907 34.872 L 29.138 34.872 L 36.303 24.007 L 13.867 24.002 Z"
    />
    <path
      fill="#00b8e3"
      d="M 16.655 24.008 L 14.53 24.63 L 12.492 24.007 L 20.815 9.505 L 22.897 13.126"
    />
    <path
      fill="#33c6e9"
      d="M 22.888 34.869 L 20.817 38.505 L 15.288 32.518 L 12.487 24.01 L 12.487 24.005 L 16.654 24.005"
    />
    <path
      fill="#008aaa"
      d="M 12.493 24.007 L 12.489 24.007 L 12.489 24.01 L 10.407 27.635 L 8.318 24.026 L 10.437 20.332 L 16.655 9.507 L 20.817 9.507"
    />
    <path
      fill="#d4d4d4"
      d="M 35.394 34.869 L 48 34.869 L 47.992 13.122 L 35.394 13.122 L 35.394 34.869 Z"
    />
    <path
      fill="#919191"
      d="M 35.394 24.036 L 35.394 34.871 L 47.977 34.871 L 47.977 24.036 L 35.394 24.036 Z"
    />
    <path
      fill="#00b8e3"
      d="M 20.819 38.509 L 16.654 38.509 L 10.407 27.634 L 12.489 24.011 L 20.819 38.509 Z"
    />
    <path
      fill="#008aaa"
      d="M 37.473 24.007 L 29.148 38.506 C 28.382 37.375 27.071 34.872 27.071 34.872 L 33.316 24.004 L 37.473 24.007 Z"
    />
    <path
      fill="#00b8e3"
      d="M 33.306 38.506 L 29.148 38.505 L 37.474 24.005 L 39.554 20.385 L 41.641 24.029 M 37.473 24.007 L 33.318 24.007 L 27.07 13.124 L 29.138 9.508 L 34.195 15.97 L 37.473 24.007 Z"
    />
    <path
      fill="#33c6e9"
      d="M 39.554 20.383 L 39.554 20.386 L 37.473 24.007 L 29.139 9.509 L 33.309 9.512 L 39.554 20.383 Z"
    />
  </svg>
);

export const openIdConnect = (
  <svg xmlns="http://www.w3.org/2000/svg" width="48px" height="48px" viewBox="0 0 48 48">
    <path
      fill="#9E9E9E"
      d="M 48 27.6 L 46.8 16.8 L 43.32 19.08 C 40.08 17.04 36 15.6 31.44 14.88 C 31.44 14.88 29.16 14.4 26.16 14.4 C 23.16 14.4 20.4 14.76 20.4 14.76 C 8.76 16.2 0 22.8 0 30.72 C 0 38.88 9 45.599 22.8 46.8 L 22.8 42.12 C 13.32 40.8 7.32 36.36 7.32 30.72 C 7.32 25.44 12.84 21 20.4 19.56 C 20.4 19.56 26.28 18.24 31.44 19.8 C 33.96 20.4 36.24 21.24 38.16 22.44 L 33.6 25.2 L 48 27.6 Z"
    />
    <path fill="#FF9800" d="M 22.8 4.8 L 22.8 46.8 L 30 43.2 L 30 1.2 L 22.8 4.8 Z" />
  </svg>
);

export const saml = (
  <svg xmlns="http://www.w3.org/2000/svg" width="32px" height="32px" viewBox="0 0 32 32">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      fill="#C22E33"
      d="M 9.003 19.353 C 10.708 6.959 15.149 0.85 15.149 0.85 C 15.149 0.85 26.439 9.5 32 22.339 C 31.698 21.959 31.227 21.235 30.62 20.303 C 26.188 13.497 14.528 -4.411 9.003 19.353 Z M 19.095 22.916 C 7.504 27.624 0 26.845 0 26.845 C 0 26.845 1.845 12.742 10.182 1.505 C 10.003 1.956 9.612 2.727 9.109 3.718 C 5.431 10.96 -4.244 30.013 19.095 22.916 Z M 30.069 26.969 C 30.069 26.969 27.008 20.078 17.135 12.383 C 34.949 29.046 13.624 30.202 5.51 30.641 C 4.397 30.702 3.533 30.749 3.052 30.82 C 16.95 32.422 30.069 26.969 30.069 26.969 Z"
    />
  </svg>
);

export const send = (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.4995 13.5001L20.9995 3.00005M10.6271 13.8281L13.2552 20.5861C13.4867 21.1815 13.6025 21.4791 13.7693 21.566C13.9139 21.6414 14.0862 21.6415 14.2308 21.5663C14.3977 21.4796 14.5139 21.1821 14.7461 20.587L21.3364 3.69925C21.5461 3.16207 21.6509 2.89348 21.5935 2.72185C21.5437 2.5728 21.4268 2.45583 21.2777 2.40604C21.1061 2.34871 20.8375 2.45352 20.3003 2.66315L3.41258 9.25349C2.8175 9.48572 2.51997 9.60183 2.43326 9.76873C2.35809 9.91342 2.35819 10.0857 2.43353 10.2303C2.52043 10.3971 2.81811 10.5128 3.41345 10.7444L10.1715 13.3725C10.2923 13.4195 10.3527 13.443 10.4036 13.4793C10.4487 13.5114 10.4881 13.5509 10.5203 13.596C10.5566 13.6468 10.5801 13.7073 10.6271 13.8281Z"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const xOutlined = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 30 30"
    width="16"
    height="16"
    fill="currentColor"
  >
    <path d="M26.37,26l-8.795-12.822l0.015,0.012L25.52,4h-2.65l-6.46,7.48L11.28,4H4.33l8.211,11.971L12.54,15.97L3.88,26h2.65 l7.182-8.322L19.42,26H26.37z M10.23,6l12.34,18h-2.1L8.12,6H10.23z" />
  </svg>
);

export const timelinePastFound = (
  <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="4" y="4.14844" width="8" height="8" rx="4" fill="currentColor" />
  </svg>
);

export const timelinePastMissing = (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.06109 15.1449C9.12361 15.5699 8.82954 15.969 8.40051 15.9901C8.26783 15.9967 8.1343 16 8 16C7.8657 16 7.73217 15.9967 7.59949 15.9901C7.17046 15.969 6.87639 15.5699 6.93891 15.1449L7.10061 14.0456C7.16312 13.6207 7.55924 13.3324 7.98879 13.3333C7.99253 13.3333 7.99626 13.3333 8 13.3333C8.00374 13.3333 8.00747 13.3333 8.01121 13.3333C8.44076 13.3324 8.83688 13.6207 8.89939 14.0456L9.06109 15.1449ZM2.63324 13.9329C2.95171 14.2211 3.44185 14.1466 3.698 13.8018L4.36058 12.9098C4.61673 12.565 4.54001 12.0814 4.23571 11.7782C4.23108 11.7736 4.22645 11.7689 4.22183 11.7643C3.91864 11.46 3.43499 11.3833 3.09017 11.6394L2.19823 12.302C1.8534 12.5581 1.77888 13.0483 2.06714 13.3668C2.24632 13.5647 2.43527 13.7537 2.63324 13.9329ZM0.00985107 8.40051C0.0310045 8.82954 0.430091 9.12361 0.855072 9.06109L1.95435 8.89939C2.37934 8.83688 2.66755 8.44076 2.66668 8.01121C2.66667 8.00747 2.66667 8.00374 2.66667 8C2.66667 7.99626 2.66667 7.99253 2.66668 7.98879C2.66755 7.55924 2.37934 7.16312 1.95435 7.10061L0.855073 6.93891C0.430091 6.87639 0.0310044 7.17046 0.00985104 7.59949C0.00330938 7.73217 0 7.8657 0 8C0 8.1343 0.00330939 8.26783 0.00985107 8.40051ZM2.06714 2.63324C1.77888 2.95171 1.8534 3.44185 2.19823 3.698L3.09017 4.36058C3.43499 4.61673 3.91864 4.54001 4.22183 4.23571C4.22645 4.23108 4.23108 4.22645 4.23571 4.22183C4.54001 3.91864 4.61673 3.43499 4.36058 3.09017L3.698 2.19823C3.44185 1.8534 2.95171 1.77888 2.63324 2.06714C2.43528 2.24632 2.24632 2.43527 2.06714 2.63324ZM6.93891 0.855072C6.87639 0.430091 7.17046 0.0310044 7.59949 0.00985106C7.73217 0.00330939 7.8657 0 8 0C8.1343 0 8.26783 0.00330938 8.40051 0.00985103C8.82954 0.0310044 9.12361 0.430091 9.06109 0.855073L8.89939 1.95435C8.83688 2.37934 8.44076 2.66755 8.01121 2.66668C8.00747 2.66667 8.00374 2.66667 8 2.66667C7.99626 2.66667 7.99253 2.66667 7.98879 2.66668C7.55924 2.66755 7.16312 2.37934 7.10061 1.95435L6.93891 0.855072ZM13.3668 2.06714C13.0483 1.77888 12.5581 1.8534 12.302 2.19823L11.6394 3.09017C11.3833 3.43499 11.46 3.91864 11.7643 4.22183C11.7689 4.22645 11.7736 4.23108 11.7782 4.23571C12.0814 4.54001 12.565 4.61673 12.9098 4.36058L13.8018 3.698C14.1466 3.44185 14.2211 2.95171 13.9329 2.63324C13.7537 2.43527 13.5647 2.24632 13.3668 2.06714ZM15.9901 7.59949C15.969 7.17046 15.5699 6.87639 15.1449 6.93891L14.0456 7.10061C13.6207 7.16312 13.3324 7.55924 13.3333 7.98879C13.3333 7.99253 13.3333 7.99626 13.3333 8C13.3333 8.00374 13.3333 8.00747 13.3333 8.01121C13.3324 8.44076 13.6207 8.83688 14.0456 8.89939L15.1449 9.06109C15.5699 9.12361 15.969 8.82954 15.9901 8.40051C15.9967 8.26783 16 8.1343 16 8C16 7.8657 15.9967 7.73217 15.9901 7.59949ZM13.9329 13.3668C14.2211 13.0483 14.1466 12.5581 13.8018 12.302L12.9098 11.6394C12.565 11.3833 12.0814 11.46 11.7782 11.7643C11.7736 11.7689 11.7689 11.7736 11.7643 11.7782C11.46 12.0814 11.3833 12.565 11.6394 12.9098L12.302 13.8018C12.5581 14.1466 13.0483 14.2211 13.3668 13.9329C13.5647 13.7537 13.7537 13.5647 13.9329 13.3668Z"
      fill="currentColor"
    />
  </svg>
);

// Looks like a target
export const timelineCurrent = (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="1" y="1" width="14" height="14" rx="7" stroke="currentColor" strokeWidth="2" />
    <rect x="4" y="4" width="8" height="8" rx="4" fill="currentColor" />
  </svg>
);

export const timelineFuture = (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="1" y="1" width="14" height="14" rx="7" stroke="currentColor" strokeWidth="2" />
  </svg>
);

export const paywallStar = (
  <svg width="21" height="18" viewBox="0 0 21 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g id="Frame 3412" clipPath="url(#clip0_816_5678)">
      <g id="vuesax/outline/star">
        <g id="star">
          <path
            id="Vector"
            d="M5.78059 5.04972L1.53714 7.15468C1.24717 7.29851 0.887426 7.17733 0.743588 6.88736C0.599749 6.5974 0.720931 6.23765 1.0109 6.09381L5.25435 3.98886C5.54432 3.84502 5.90406 3.96621 6.0479 4.25617C6.19174 4.54614 6.07055 4.90589 5.78059 5.04972Z"
            fill="currentColor"
          />
          <path
            id="Vector_2"
            d="M8.57097 16.0036L6.44925 17.056C6.15928 17.1999 5.79954 17.0787 5.6557 16.7887C5.51186 16.4988 5.63304 16.139 5.92301 15.9952L8.04473 14.9427C8.3347 14.7989 8.69444 14.92 8.83828 15.21C8.98212 15.5 8.86094 15.8597 8.57097 16.0036Z"
            fill="currentColor"
          />
          <path
            id="Vector_3"
            d="M4.69946 11.7545L3.99222 12.1054C3.70225 12.2492 3.3425 12.128 3.19867 11.838C3.05483 11.5481 3.17601 11.1883 3.46598 11.0445L4.17322 10.6937C4.46319 10.5498 4.82293 10.671 4.96677 10.961C5.11061 11.251 4.98943 11.6107 4.69946 11.7545Z"
            fill="currentColor"
          />
        </g>
      </g>
      <g id="Vector_4">
        <path
          d="M20.1807 9.01105L16.9796 6.48574L17.2458 2.41706C17.2532 2.30572 17.2236 2.19501 17.1615 2.10229C17.006 1.86939 16.6901 1.80629 16.4559 1.96097L13.0654 4.22591L9.27786 2.71629C9.17358 2.67443 9.05927 2.66899 8.95211 2.69887C8.8222 2.7356 8.71218 2.82239 8.64624 2.94019C8.58029 3.05799 8.56381 3.19715 8.60041 3.32709L9.70551 7.25167L7.09868 10.3874C7.03793 10.4603 6.99881 10.5487 6.98577 10.6427C6.97272 10.7367 6.98627 10.8325 7.02488 10.9191C7.06348 11.0058 7.1256 11.0799 7.20419 11.1331C7.28277 11.1862 7.37469 11.2163 7.4695 11.2199L11.5438 11.3812L13.7205 14.829C13.7796 14.9236 13.87 14.996 13.9745 15.0343C14.2378 15.1313 14.5299 14.9971 14.6269 14.7338L16.0391 10.9084L19.9905 9.90314C20.0982 9.87544 20.1945 9.81357 20.2639 9.72518C20.4401 9.50579 20.4009 9.18589 20.1807 9.01105ZM15.1755 9.94734L14.0013 13.1285L12.1898 10.2622L8.80095 10.1279L10.9688 7.52044L10.0498 4.25565L13.2004 5.51132L16.0197 3.6286L15.7989 7.01151L18.4616 9.11221L15.1755 9.94734Z"
          fill="currentColor"
        />
        <path
          d="M15.1755 9.94734L14.0013 13.1285L12.1898 10.2622L8.80095 10.1279L10.9688 7.52044L10.0498 4.25565L13.2004 5.51132L16.0197 3.6286L15.7989 7.01151L18.4616 9.11221L15.1755 9.94734Z"
          fill="currentColor"
        />
      </g>
    </g>
    <defs>
      <linearGradient
        id="paint0_linear_816_5678"
        x1="5.78478"
        y1="3.72574"
        x2="6.32695"
        y2="6.16161"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor={yellow600} />
        <stop offset="1" stopColor="currentColor" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_816_5678"
        x1="8.57516"
        y1="14.6796"
        x2="8.7438"
        y2="17.0511"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor={yellow600} />
        <stop offset="1" stopColor="currentColor" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_816_5678"
        x1="4.70365"
        y1="10.4306"
        x2="4.34206"
        y2="12.4657"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor={yellow600} />
        <stop offset="1" stopColor="currentColor" />
      </linearGradient>
      <linearGradient
        id="paint3_linear_816_5678"
        x1="22.8205"
        y1="5.30893"
        x2="5.04499"
        y2="8.56429"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor={yellow600} />
        <stop offset="1" stopColor="currentColor" />
      </linearGradient>
      <linearGradient
        id="paint4_linear_816_5678"
        x1="22.8205"
        y1="5.30893"
        x2="5.04499"
        y2="8.56429"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor={yellow600} />
        <stop offset="1" stopColor="currentColor" />
      </linearGradient>
      <clipPath id="clip0_816_5678">
        <rect width="20.8421" height="18" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

// Below are all the part icons as part of the new brand identity and all that jazz.
export const together = (
  <svg
    width="400"
    height="400"
    viewBox="0 0 400 400"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M200 144.525C189.466 169.478 169.48 189.465 144.528 200C169.48 210.536 189.466 230.523 200 255.475C210.534 230.523 230.52 210.536 255.472 200C230.52 189.465 210.534 169.478 200 144.525ZM200 63.6313C184.216 26.2428 147.21 0.00231934 104.076 0.00231934C46.5964 0.00231934 0 46.5987 0 104.078C0 147.21 26.2379 184.214 63.6235 200C26.2379 215.786 6.10352e-05 252.79 6.10352e-05 295.922C6.10352e-05 353.402 46.5964 399.998 104.076 399.998C147.21 399.998 184.216 373.758 200 336.369C215.785 373.758 252.79 399.998 295.924 399.998C353.404 399.998 400 353.402 400 295.922C400 252.79 373.762 215.786 336.377 200C373.762 184.214 400 147.21 400 104.078C400 46.5988 353.404 0.00238037 295.924 0.00238037C252.79 0.00238037 215.785 26.2428 200 63.6313Z"
      fill="#256BFF"
    />
  </svg>
);

export const bidPart = (
  <svg
    width="400"
    height="400"
    viewBox="0 0 400 400"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2.44258e-06 130.018C-0.0137655 58.221 58.1781 0.00996436 129.975 1.27814e-06C201.772 -0.00995814 259.986 58.185 260 129.982C260.001 133.341 259.874 136.67 259.624 139.965L139.975 139.982L139.998 259.622C136.706 259.872 133.381 260 130.025 260C58.2279 260.01 0.0137731 201.815 2.44258e-06 130.018Z"
      fill="#FF2135"
    />
    <path
      d="M140.33 259.982C140.078 263.294 139.95 266.641 139.95 270.018C139.964 341.815 198.178 400.01 269.975 400C341.772 399.99 399.964 341.779 399.95 269.982C399.936 198.185 341.722 139.99 269.925 140C266.577 140 263.259 140.127 259.975 140.376L259.998 259.965L140.33 259.982Z"
      fill="#FF2135"
    />
  </svg>
);

export const tenderPart = (
  <svg
    width="400"
    height="400"
    viewBox="0 0 400 400"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M199.999 399.98H199.996L199.996 201.783C199.044 311.418 109.869 400 0.00338745 400H3.05176e-05V0.0197754L0.00338745 0.0197754C109.869 0.0197754 199.044 88.6016 199.996 198.237L199.996 0H199.999C310.457 1.93135e-05 400 89.5386 400 199.99C400 310.441 310.457 399.98 199.999 399.98Z"
      fill="#613DC3"
    />
  </svg>
);

export const strategyPart = (
  <svg
    width="400"
    height="400"
    viewBox="0 0 400 400"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M200 310.513C261.035 310.513 310.513 261.035 310.513 200C310.513 138.965 261.035 89.4867 200 89.4867C138.965 89.4867 89.4867 138.965 89.4867 200C89.4867 261.035 138.965 310.513 200 310.513ZM200 400C310.457 400 400 310.457 400 200C400 89.543 310.457 0 200 0C89.543 0 0 89.543 0 200C0 310.457 89.543 400 200 400Z"
      fill="#FFC82F"
    />
  </svg>
);

export const pipelinePart = (
  <svg
    width="400"
    height="400"
    viewBox="0 0 400 400"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M58.6201 58L200.137 199.517L58.6183 341.035C-19.5384 262.879 -19.5399 136.16 58.6167 58.0034L58.6201 58Z"
      fill="#16BAC5"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M341.379 341.037L199.863 199.521L341.382 58.0021C419.539 136.159 419.54 262.877 341.383 341.034L341.379 341.037Z"
      fill="#16BAC5"
    />
  </svg>
);

export const aiStars = (
  <svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.67689 0.46875C9.93651 0.46875 10.1693 0.628643 10.2625 0.870959L11.002 2.79373C11.1905 3.2838 11.2498 3.42502 11.3308 3.53896C11.4121 3.65329 11.512 3.75317 11.6263 3.83447C11.7402 3.91548 11.8815 3.97471 12.3715 4.1632L14.2943 4.90273C14.5366 4.99593 14.6965 5.22874 14.6965 5.48836C14.6965 5.74798 14.5366 5.98079 14.2943 6.07399L12.3715 6.81351C11.8815 7.002 11.7402 7.06123 11.6263 7.14225C11.512 7.22354 11.4121 7.32343 11.3308 7.43776C11.2498 7.5517 11.1905 7.69292 11.002 8.18299L10.2625 10.1058C10.1693 10.3481 9.93651 10.508 9.67689 10.508C9.41727 10.508 9.18446 10.3481 9.09126 10.1058L8.35174 8.18298C8.16325 7.69292 8.10402 7.5517 8.023 7.43776C7.94171 7.32343 7.84182 7.22354 7.72749 7.14225C7.61355 7.06123 7.47233 7.002 6.98227 6.81351L5.05949 6.07399C4.81718 5.98079 4.65728 5.74798 4.65728 5.48836C4.65728 5.22874 4.81718 4.99593 5.05949 4.90273L6.98227 4.1632C7.47233 3.97471 7.61355 3.91548 7.72749 3.83447C7.84182 3.75317 7.94171 3.65329 8.023 3.53896C8.10402 3.42502 8.16325 3.2838 8.35174 2.79373L9.09126 0.870959C9.18446 0.628643 9.41727 0.46875 9.67689 0.46875ZM9.67689 2.84408L9.52299 3.24422C9.51467 3.26585 9.50648 3.28719 9.49838 3.30827C9.34555 3.70624 9.2301 4.00686 9.04572 4.26617C8.88313 4.49482 8.68336 4.6946 8.4547 4.85718C8.19539 5.04157 7.89477 5.15701 7.4968 5.30985C7.47573 5.31794 7.45438 5.32614 7.43275 5.33446L7.03261 5.48836L7.43275 5.64226C7.45438 5.65058 7.47573 5.65878 7.49681 5.66687C7.89477 5.8197 8.19539 5.93515 8.4547 6.11953C8.68336 6.28212 8.88313 6.48189 9.04572 6.71055C9.2301 6.96986 9.34555 7.27048 9.49838 7.66845C9.50648 7.68952 9.51467 7.71087 9.52299 7.7325L9.67689 8.13264L9.83079 7.7325C9.83911 7.71087 9.84731 7.68952 9.8554 7.66845C10.0082 7.27048 10.1237 6.96986 10.3081 6.71055C10.4707 6.48189 10.6704 6.28212 10.8991 6.11953C11.1584 5.93515 11.459 5.8197 11.857 5.66687C11.8781 5.65877 11.8994 5.65058 11.921 5.64226L12.3212 5.48836L11.921 5.33446C11.8994 5.32614 11.8781 5.31794 11.857 5.30985C11.459 5.15701 11.1584 5.04157 10.8991 4.85718C10.6704 4.6946 10.4707 4.49482 10.3081 4.26617C10.1237 4.00686 10.0082 3.70624 9.8554 3.30827C9.84731 3.28719 9.83911 3.26585 9.83079 3.24422L9.67689 2.84408ZM4.34356 7.37071C4.58122 7.37071 4.79848 7.50499 4.90477 7.71756L5.39698 8.70198C5.57422 9.05647 5.62823 9.15848 5.69386 9.24362C5.75969 9.32901 5.83624 9.40557 5.92163 9.47139C6.00677 9.53702 6.10878 9.59103 6.46327 9.76827L7.44769 10.2605C7.66026 10.3668 7.79454 10.584 7.79454 10.8217C7.79454 11.0594 7.66026 11.2766 7.44769 11.3829L6.46327 11.8751C6.10879 12.0524 6.00677 12.1064 5.92163 12.172C5.83624 12.2378 5.75968 12.3144 5.69386 12.3998C5.62823 12.4849 5.57422 12.5869 5.39698 12.9414L4.90477 13.9258C4.79848 14.1384 4.58122 14.2727 4.34356 14.2727C4.1059 14.2727 3.88864 14.1384 3.78235 13.9258L3.29014 12.9414C3.11289 12.5869 3.05888 12.4849 2.99326 12.3998C2.92743 12.3144 2.85088 12.2378 2.76548 12.172C2.68034 12.1064 2.57833 12.0524 2.22384 11.8751L1.23942 11.3829C1.02685 11.2766 0.892578 11.0594 0.892578 10.8217C0.892578 10.584 1.02685 10.3668 1.23942 10.2605L2.22384 9.76827C2.57833 9.59103 2.68034 9.53702 2.76548 9.47139C2.85088 9.40557 2.92743 9.32901 2.99326 9.24362C3.05888 9.15848 3.1129 9.05647 3.29014 8.70198L3.78235 7.71756C3.88863 7.50499 4.1059 7.37071 4.34356 7.37071ZM4.34356 9.40117C4.22107 9.64528 4.12 9.8374 3.98716 10.0097C3.85551 10.1805 3.7024 10.3336 3.53161 10.4653C3.35926 10.5981 3.16715 10.6992 2.92304 10.8217C3.16715 10.9442 3.35926 11.0452 3.53161 11.1781C3.70239 11.3097 3.85551 11.4629 3.98716 11.6336C4.12 11.806 4.22107 11.9981 4.34356 12.2422C4.46605 11.9981 4.56711 11.806 4.69996 11.6336C4.83161 11.4629 4.98472 11.3097 5.15551 11.1781C5.32786 11.0452 5.51997 10.9442 5.76408 10.8217C5.51997 10.6992 5.32786 10.5981 5.15551 10.4653C4.98472 10.3336 4.83161 10.1805 4.69996 10.0097C4.56711 9.83739 4.46605 9.64528 4.34356 9.40117Z"
      fill="currentColor"
    />
    <path
      d="M12.039 10.6611L12.149 10.375C12.2581 10.0913 12.3127 9.94945 12.3914 9.9083C12.4597 9.87264 12.5411 9.87264 12.6094 9.9083C12.6881 9.94945 12.7427 10.0913 12.8518 10.375L12.9618 10.6611L12.9786 10.7048C13.0828 10.9761 13.1615 11.1811 13.2873 11.3579C13.3981 11.5138 13.5343 11.65 13.6902 11.7609C13.867 11.8866 14.072 11.9653 14.3433 12.0695L14.387 12.0863L14.6732 12.1964C14.9568 12.3055 15.0987 12.36 15.1398 12.4388C15.1755 12.507 15.1755 12.5884 15.1398 12.6567C15.0987 12.7355 14.9568 12.79 14.6732 12.8991L14.387 13.0092L14.3433 13.026C14.072 13.1302 13.867 13.2089 13.6902 13.3346C13.5343 13.4454 13.3981 13.5817 13.2873 13.7376C13.1615 13.9144 13.0828 14.1193 12.9786 14.3907L12.9618 14.4343L12.8518 14.7205C12.7427 15.0042 12.6881 15.146 12.6094 15.1872C12.5411 15.2228 12.4597 15.2228 12.3914 15.1872C12.3127 15.146 12.2581 15.0042 12.149 14.7205L12.039 14.4343L12.0222 14.3907C11.918 14.1193 11.8393 13.9144 11.7135 13.7376C11.6027 13.5817 11.4665 13.4454 11.3106 13.3346C11.1338 13.2089 10.9288 13.1302 10.6575 13.026L10.6138 13.0092L10.3276 12.8991C10.044 12.79 9.90211 12.7355 9.86097 12.6567C9.82531 12.5884 9.8253 12.507 9.86097 12.4388C9.90211 12.36 10.044 12.3055 10.3276 12.1964L10.6138 12.0863L10.6575 12.0695C10.9288 11.9653 11.1338 11.8866 11.3106 11.7609C11.4665 11.65 11.6027 11.5138 11.7135 11.3579C11.8393 11.1811 11.918 10.9761 12.0222 10.7048L12.039 10.6611Z"
      fill="currentColor"
    />
  </svg>
);

export const aiFile = (
  <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.83913 0.666016H10.1609C10.6975 0.666007 11.1404 0.666 11.5012 0.695479C11.876 0.726095 12.2204 0.791805 12.544 0.956666C13.0457 1.21233 13.4537 1.62028 13.7094 2.12204C13.8742 2.4456 13.9399 2.79007 13.9705 3.1648C14 3.52559 14 3.96849 14 4.50513V11.4936C14 12.0302 14 12.4731 13.9705 12.8339C13.9399 13.2086 13.8742 13.5531 13.7094 13.8767C13.4537 14.3784 13.0457 14.7864 12.544 15.042C12.2204 15.2069 11.876 15.2726 11.5012 15.3032C11.1404 15.3327 10.6975 15.3327 10.1609 15.3327H5.83912C5.30248 15.3327 4.85958 15.3327 4.49878 15.3032C4.12405 15.2726 3.77958 15.2069 3.45603 15.042C2.95426 14.7864 2.54631 14.3784 2.29065 13.8767C2.12579 13.5531 2.06008 13.2086 2.02946 12.8339C1.99998 12.4731 1.99999 12.0302 2 11.4935V4.50515C1.99999 3.9685 1.99998 3.5256 2.02946 3.1648C2.06008 2.79007 2.12579 2.4456 2.29065 2.12204C2.54631 1.62028 2.95426 1.21233 3.45603 0.956666C3.77958 0.791805 4.12405 0.726095 4.49878 0.695479C4.85958 0.666 5.30249 0.666007 5.83913 0.666016ZM4.60736 2.02438C4.31508 2.04826 4.16561 2.09155 4.06135 2.14467C3.81046 2.27251 3.60649 2.47648 3.47866 2.72736C3.42553 2.83163 3.38225 2.9811 3.35837 3.27337C3.33385 3.57343 3.33333 3.96163 3.33333 4.53268V11.466C3.33333 12.0371 3.33385 12.4253 3.35837 12.7253C3.38225 13.0176 3.42553 13.1671 3.47866 13.2713C3.60649 13.5222 3.81046 13.7262 4.06135 13.854C4.16561 13.9072 4.31508 13.9504 4.60736 13.9743C4.90742 13.9988 5.29561 13.9993 5.86667 13.9993H10.1333C10.7044 13.9993 11.0926 13.9988 11.3926 13.9743C11.6849 13.9504 11.8344 13.9072 11.9387 13.854C12.1895 13.7262 12.3935 13.5222 12.5213 13.2713C12.5745 13.1671 12.6178 13.0176 12.6416 12.7253C12.6661 12.4253 12.6667 12.0371 12.6667 11.466V4.53268C12.6667 3.96163 12.6661 3.57343 12.6416 3.27337C12.6178 2.9811 12.5745 2.83163 12.5213 2.72736C12.3935 2.47648 12.1895 2.27251 11.9387 2.14467C11.8344 2.09155 11.6849 2.04826 11.3926 2.02438C11.0926 1.99987 10.7044 1.99935 10.1333 1.99935H5.86667C5.29561 1.99935 4.90742 1.99987 4.60736 2.02438ZM4.66667 4.66602C4.66667 4.29783 4.96514 3.99935 5.33333 3.99935H10.6667C11.0349 3.99935 11.3333 4.29783 11.3333 4.66602C11.3333 5.03421 11.0349 5.33268 10.6667 5.33268H5.33333C4.96514 5.33268 4.66667 5.03421 4.66667 4.66602ZM4.66667 7.33268C4.66667 6.96449 4.96514 6.66602 5.33333 6.66602H9.33333C9.70152 6.66602 10 6.96449 10 7.33268C10 7.70087 9.70152 7.99935 9.33333 7.99935H5.33333C4.96514 7.99935 4.66667 7.70087 4.66667 7.33268ZM4.66667 9.99935C4.66667 9.63116 4.96514 9.33268 5.33333 9.33268H6.66667C7.03486 9.33268 7.33333 9.63116 7.33333 9.99935C7.33333 10.3675 7.03486 10.666 6.66667 10.666H5.33333C4.96514 10.666 4.66667 10.3675 4.66667 9.99935Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13 7.5C13.1881 7.5 13.3567 7.61583 13.4242 7.79137L14.3388 10.1691C14.4753 10.5242 14.5182 10.6265 14.5769 10.709C14.6358 10.7918 14.7082 10.8642 14.791 10.9231C14.8735 10.9818 14.9758 11.0247 15.3309 11.1612L17.7086 12.0758C17.8842 12.1433 18 12.3119 18 12.5C18 12.6881 17.8842 12.8567 17.7086 12.9242L15.3309 13.8388C14.9758 13.9753 14.8735 14.0182 14.791 14.0769C14.7082 14.1358 14.6358 14.2082 14.5769 14.291C14.5182 14.3735 14.4753 14.4758 14.3388 14.8309L13.4242 17.2086C13.3567 17.3842 13.1881 17.5 13 17.5C12.8119 17.5 12.6433 17.3842 12.5758 17.2086L11.6612 14.8309C11.5247 14.4758 11.4818 14.3735 11.4231 14.291C11.3642 14.2082 11.2918 14.1358 11.209 14.0769C11.1265 14.0182 11.0242 13.9753 10.6691 13.8388L8.29137 12.9242C8.11583 12.8567 8 12.6881 8 12.5C8 12.3119 8.11583 12.1433 8.29137 12.0758L10.6691 11.1612C11.0242 11.0247 11.1265 10.9818 11.209 10.9231C11.2918 10.8642 11.3642 10.7918 11.4231 10.709C11.4818 10.6265 11.5247 10.5242 11.6612 10.1691L12.5758 7.79137C12.6433 7.61583 12.8119 7.5 13 7.5ZM13 9.22076L12.5097 10.4955C12.5037 10.5112 12.4978 10.5266 12.4919 10.5419C12.3812 10.8302 12.2975 11.048 12.164 11.2358C12.0462 11.4015 11.9015 11.5462 11.7358 11.664C11.548 11.7975 11.3302 11.8812 11.0419 11.9919C11.0266 11.9978 11.0112 12.0037 10.9955 12.0097L9.72076 12.5L10.9955 12.9903C11.0112 12.9963 11.0266 13.0022 11.0419 13.0081C11.3302 13.1188 11.548 13.2025 11.7358 13.336C11.9015 13.4538 12.0462 13.5985 12.164 13.7642C12.2975 13.952 12.3812 14.1698 12.4919 14.4581C12.4978 14.4734 12.5037 14.4888 12.5097 14.5045L13 15.7792L13.4903 14.5045C13.4963 14.4888 13.5022 14.4734 13.5081 14.4581C13.6188 14.1698 13.7025 13.952 13.836 13.7642C13.9538 13.5985 14.0985 13.4538 14.2642 13.336C14.452 13.2025 14.6698 13.1188 14.9581 13.0081C14.9734 13.0022 14.9888 12.9963 15.0045 12.9903L16.2792 12.5L15.0045 12.0097C14.9888 12.0037 14.9734 11.9978 14.9581 11.9919C14.6698 11.8812 14.452 11.7975 14.2642 11.664C14.0985 11.5462 13.9538 11.4015 13.836 11.2358C13.7025 11.048 13.6188 10.8302 13.5081 10.5419C13.5022 10.5266 13.4963 10.5112 13.4903 10.4955L13 9.22076Z"
      fill="#EDF3FF"
    />
    <path
      d="M12.5097 10.4955L13 9.22076L13.4903 10.4955L13.5081 10.5419C13.6188 10.8302 13.7025 11.048 13.836 11.2358C13.9538 11.4015 14.0985 11.5462 14.2642 11.664C14.452 11.7975 14.6698 11.8812 14.9581 11.9919L15.0045 12.0097L16.2792 12.5L15.0045 12.9903L14.9581 13.0081C14.6698 13.1188 14.452 13.2025 14.2642 13.336C14.0985 13.4538 13.9538 13.5985 13.836 13.7642C13.7025 13.952 13.6188 14.1698 13.5081 14.4581L13.4903 14.5045L13 15.7792L12.5097 14.5045L12.4919 14.4581C12.3812 14.1698 12.2975 13.952 12.164 13.7642C12.0462 13.5985 11.9015 13.4538 11.7358 13.336C11.548 13.2025 11.3302 13.1188 11.0419 13.0081L10.9955 12.9903L9.72076 12.5L10.9955 12.0097L11.0419 11.9919C11.3302 11.8812 11.548 11.7975 11.7358 11.664C11.9015 11.5462 12.0462 11.4015 12.164 11.2358C12.2975 11.048 12.3812 10.8302 12.4919 10.5419L12.5097 10.4955Z"
      fill="currentColor"
    />
  </svg>
);

export const aiBuilding = (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_3438_108613)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.77907 0.751421C7.92493 0.718276 8.07637 0.718276 8.22224 0.751421C8.39546 0.790783 8.54477 0.886187 8.61675 0.932182C8.62424 0.936967 8.63089 0.941217 8.63665 0.944814L13.6873 4.10148C13.9395 4.25911 14.0568 4.56472 13.9748 4.8506C13.8928 5.13648 13.6314 5.33348 13.334 5.33348H2.66732C2.36991 5.33348 2.10847 5.13648 2.02649 4.8506C1.9445 4.56472 2.06178 4.25911 2.31399 4.10148L7.36465 0.944814C7.37041 0.941217 7.37706 0.936967 7.38455 0.932182C7.45653 0.886187 7.60585 0.790783 7.77907 0.751421ZM8.00065 2.11965L4.99185 4.00015H11.0095L8.00065 2.11965ZM4.00065 6.00015C4.36884 6.00015 4.66732 6.29862 4.66732 6.66681V12.0001C4.66732 12.3683 4.36884 12.6668 4.00065 12.6668C3.63246 12.6668 3.33398 12.3683 3.33398 12.0001V6.66681C3.33398 6.29862 3.63246 6.00015 4.00065 6.00015ZM6.66732 6.00015C7.03551 6.00015 7.33398 6.29862 7.33398 6.66681V12.0001C7.33398 12.3683 7.03551 12.6668 6.66732 12.6668C6.29913 12.6668 6.00065 12.3683 6.00065 12.0001V6.66681C6.00065 6.29862 6.29913 6.00015 6.66732 6.00015ZM9.33398 6.00015C9.70217 6.00015 10.0007 6.29862 10.0007 6.66681V12.0001C10.0007 12.3683 9.70217 12.6668 9.33398 12.6668C8.96579 12.6668 8.66732 12.3683 8.66732 12.0001V6.66681C8.66732 6.29862 8.96579 6.00015 9.33398 6.00015ZM12.0007 6.00015C12.3688 6.00015 12.6673 6.29862 12.6673 6.66681V12.0001C12.6673 12.3683 12.3688 12.6668 12.0007 12.6668C11.6325 12.6668 11.334 12.3683 11.334 12.0001V6.66681C11.334 6.29862 11.6325 6.00015 12.0007 6.00015ZM1.33398 14.0001C1.33398 13.632 1.63246 13.3335 2.00065 13.3335H14.0007C14.3688 13.3335 14.6673 13.632 14.6673 14.0001C14.6673 14.3683 14.3688 14.6668 14.0007 14.6668H2.00065C1.63246 14.6668 1.33398 14.3683 1.33398 14.0001Z"
        fill="#263247"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.5 7.5C12.6881 7.5 12.8567 7.61583 12.9242 7.79137L13.8388 10.1691C13.9753 10.5242 14.0182 10.6265 14.0769 10.709C14.1358 10.7918 14.2082 10.8642 14.291 10.9231C14.3735 10.9818 14.4758 11.0247 14.8309 11.1612L17.2086 12.0758C17.3842 12.1433 17.5 12.3119 17.5 12.5C17.5 12.6881 17.3842 12.8567 17.2086 12.9242L14.8309 13.8388C14.4758 13.9753 14.3735 14.0182 14.291 14.0769C14.2082 14.1358 14.1358 14.2082 14.0769 14.291C14.0182 14.3735 13.9753 14.4758 13.8388 14.8309L12.9242 17.2086C12.8567 17.3842 12.6881 17.5 12.5 17.5C12.3119 17.5 12.1433 17.3842 12.0758 17.2086L11.1612 14.8309C11.0247 14.4758 10.9818 14.3735 10.9231 14.291C10.8642 14.2082 10.7918 14.1358 10.709 14.0769C10.6265 14.0182 10.5242 13.9753 10.1691 13.8388L7.79137 12.9242C7.61583 12.8567 7.5 12.6881 7.5 12.5C7.5 12.3119 7.61583 12.1433 7.79137 12.0758L10.1691 11.1612C10.5242 11.0247 10.6265 10.9818 10.709 10.9231C10.7918 10.8642 10.8642 10.7918 10.9231 10.709C10.9818 10.6265 11.0247 10.5242 11.1612 10.1691L12.0758 7.79137C12.1433 7.61583 12.3119 7.5 12.5 7.5ZM12.5 9.22076L12.0097 10.4955C12.0037 10.5112 11.9978 10.5266 11.9919 10.5419C11.8812 10.8302 11.7975 11.048 11.664 11.2358C11.5462 11.4015 11.4015 11.5462 11.2358 11.664C11.048 11.7975 10.8302 11.8812 10.5419 11.9919C10.5266 11.9978 10.5112 12.0037 10.4955 12.0097L9.22076 12.5L10.4955 12.9903C10.5112 12.9963 10.5266 13.0022 10.5419 13.0081C10.8302 13.1188 11.048 13.2025 11.2358 13.336C11.4015 13.4538 11.5462 13.5985 11.664 13.7642C11.7975 13.952 11.8812 14.1698 11.9919 14.4581C11.9978 14.4734 12.0037 14.4888 12.0097 14.5045L12.5 15.7792L12.9903 14.5045C12.9963 14.4888 13.0022 14.4734 13.0081 14.4581C13.1188 14.1698 13.2025 13.952 13.336 13.7642C13.4538 13.5985 13.5985 13.4538 13.7642 13.336C13.952 13.2025 14.1698 13.1188 14.4581 13.0081C14.4734 13.0022 14.4888 12.9963 14.5045 12.9903L15.7792 12.5L14.5045 12.0097C14.4888 12.0037 14.4734 11.9978 14.4581 11.9919C14.1698 11.8812 13.952 11.7975 13.7642 11.664C13.5985 11.5462 13.4538 11.4015 13.336 11.2358C13.2025 11.048 13.1188 10.8302 13.0081 10.5419C13.0022 10.5266 12.9963 10.5112 12.9903 10.4955L12.5 9.22076Z"
        fill="#F7F7F8"
      />
      <path
        d="M12.0097 10.4955L12.5 9.22076L12.9903 10.4955L13.0081 10.5419C13.1188 10.8302 13.2025 11.048 13.336 11.2358C13.4538 11.4015 13.5985 11.5462 13.7642 11.664C13.952 11.7975 14.1698 11.8812 14.4581 11.9919L14.5045 12.0097L15.7792 12.5L14.5045 12.9903L14.4581 13.0081C14.1698 13.1188 13.952 13.2025 13.7642 13.336C13.5985 13.4538 13.4538 13.5985 13.336 13.7642C13.2025 13.952 13.1188 14.1698 13.0081 14.4581L12.9903 14.5045L12.5 15.7792L12.0097 14.5045L11.9919 14.4581C11.8812 14.1698 11.7975 13.952 11.664 13.7642C11.5462 13.5985 11.4015 13.4538 11.2358 13.336C11.048 13.2025 10.8302 13.1188 10.5419 13.0081L10.4955 12.9903L9.22076 12.5L10.4955 12.0097L10.5419 11.9919C10.8302 11.8812 11.048 11.7975 11.2358 11.664C11.4015 11.5462 11.5462 11.4015 11.664 11.2358C11.7975 11.048 11.8812 10.8302 11.9919 10.5419L12.0097 10.4955Z"
        fill="#FFD359"
      />
      <rect x="13.5" y="13.5" width="2" height="2" rx="1" fill="#F7F7F8" />
    </g>
    <defs>
      <clipPath id="clip0_3438_108613">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const dragIcon = (
  <svg width="8" height="12" viewBox="0 0 8 12" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0.333252 1.33333C0.333252 0.596954 0.930206 0 1.66659 0C2.40297 0 2.99992 0.596954 2.99992 1.33333C2.99992 2.06971 2.40297 2.66667 1.66659 2.66667C0.930206 2.66667 0.333252 2.06971 0.333252 1.33333ZM4.99992 1.33333C4.99992 0.596954 5.59687 0 6.33325 0C7.06963 0 7.66659 0.596954 7.66659 1.33333C7.66659 2.06971 7.06963 2.66667 6.33325 2.66667C5.59687 2.66667 4.99992 2.06971 4.99992 1.33333ZM0.333252 6C0.333252 5.26362 0.930206 4.66667 1.66659 4.66667C2.40297 4.66667 2.99992 5.26362 2.99992 6C2.99992 6.73638 2.40297 7.33333 1.66659 7.33333C0.930206 7.33333 0.333252 6.73638 0.333252 6ZM4.99992 6C4.99992 5.26362 5.59687 4.66667 6.33325 4.66667C7.06963 4.66667 7.66659 5.26362 7.66659 6C7.66659 6.73638 7.06963 7.33333 6.33325 7.33333C5.59687 7.33333 4.99992 6.73638 4.99992 6ZM0.333252 10.6667C0.333252 9.93029 0.930206 9.33333 1.66659 9.33333C2.40297 9.33333 2.99992 9.93029 2.99992 10.6667C2.99992 11.403 2.40297 12 1.66659 12C0.930206 12 0.333252 11.403 0.333252 10.6667ZM4.99992 10.6667C4.99992 9.93029 5.59687 9.33333 6.33325 9.33333C7.06963 9.33333 7.66659 9.93029 7.66659 10.6667C7.66659 11.403 7.06963 12 6.33325 12C5.59687 12 4.99992 11.403 4.99992 10.6667Z"
      fill="#4F5A6F"
    />
  </svg>
);

export const sparkles = (
  <svg width="16" height="16" viewBox="0 0 56 56" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g id="AI Stars">
      <path
        id="Vector 4 (Stroke)"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.375 1.75C19.0472 1.75 19.6208 2.27332 19.7313 2.98733L20.5712 8.41474C21.2888 13.051 23.7562 17.1607 27.3877 19.7679C27.7702 20.0426 28 20.5049 28 21C28 21.4951 27.7702 21.9574 27.3877 22.2321C23.7562 24.8393 21.2888 28.949 20.5712 33.5853L19.7313 39.0127C19.6208 39.7267 19.0472 40.25 18.375 40.25C17.7028 40.25 17.1292 39.7267 17.0187 39.0127L16.1788 33.5853C15.4612 28.949 12.9938 24.8393 9.36229 22.2321C8.97976 21.9574 8.75 21.4951 8.75 21C8.75 20.5049 8.97976 20.0426 9.36229 19.7679C12.9938 17.1607 15.4612 13.051 16.1788 8.41474L17.0187 2.98733C17.1292 2.27332 17.7028 1.75 18.375 1.75Z"
        fill="currentColor"
      />
      <path
        id="Vector 4 (Stroke)_2"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M37.625 17.5C38.2972 17.5 38.8708 17.9995 38.9813 18.6811L39.8212 23.8618C40.5388 28.2873 43.0062 32.2102 46.6377 34.6989C47.0202 34.9611 47.25 35.4024 47.25 35.875C47.25 36.3476 47.0202 36.7889 46.6377 37.0511C43.0062 39.5398 40.5388 43.4627 39.8212 47.8882L38.9813 53.0689C38.8708 53.7505 38.2972 54.25 37.625 54.25C36.9528 54.25 36.3792 53.7505 36.2687 53.0689L35.4288 47.8882C34.7112 43.4627 32.2438 39.5398 28.6123 37.0511C28.2298 36.7889 28 36.3476 28 35.875C28 35.4024 28.2298 34.9611 28.6123 34.6989C32.2438 32.2102 34.7112 28.2873 35.4288 23.8618L36.2687 18.6811C36.3792 17.9995 36.9528 17.5 37.625 17.5Z"
        fill="currentColor"
      />
    </g>
  </svg>
);

export const sparklesFilled = (
  <svg xmlns="http://www.w3.org/2000/svg" width="21" height="31" viewBox="0 0 21 31" fill="none">
    <path
      d="M6.23515 17.3483L5.75154 20.25L5.26793 17.3483C4.81884 14.6538 3.27447 12.2653 1.00154 10.75C3.27447 9.23471 4.81884 6.84622 5.26793 4.15166L5.75154 1.25L6.23515 4.15166C6.68424 6.84622 8.22861 9.23471 10.5015 10.75C8.22861 12.2653 6.68424 14.6538 6.23515 17.3483Z"
      fill="url(#paint0_linear_436_18579)"
      stroke="url(#paint1_linear_436_18579)"
      strokeWidth="1.58333"
      strokeLinejoin="round"
    />
    <path
      d="M15.7321 26.8483L15.2485 29.75L14.7648 26.8483C14.3158 24.1538 12.7714 21.7653 10.4985 20.25C12.7714 18.7347 14.3158 16.3462 14.7648 13.6517L15.2485 10.75L15.7321 13.6517C16.1812 16.3462 17.7255 18.7347 19.9985 20.25C17.7255 21.7653 16.1812 24.1538 15.7321 26.8483Z"
      fill="url(#paint2_linear_436_18579)"
      stroke="url(#paint3_linear_436_18579)"
      strokeWidth="1.58333"
      strokeLinejoin="round"
    />
    <defs>
      <linearGradient
        id="paint0_linear_436_18579"
        x1="10.5015"
        y1="1.25"
        x2="-3.87194"
        y2="7.08631"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FFD86C" />
        <stop offset="1" stopColor="#FFC932" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_436_18579"
        x1="10.5015"
        y1="1.25"
        x2="-3.87194"
        y2="7.08631"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FFD86C" />
        <stop offset="1" stopColor="#FFC932" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_436_18579"
        x1="19.9985"
        y1="10.75"
        x2="5.62498"
        y2="16.5863"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FFD86C" />
        <stop offset="1" stopColor="#FFC932" />
      </linearGradient>
      <linearGradient
        id="paint3_linear_436_18579"
        x1="19.9985"
        y1="10.75"
        x2="5.62498"
        y2="16.5863"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FFD86C" />
        <stop offset="1" stopColor="#FFC932" />
      </linearGradient>
    </defs>
  </svg>
);

// Untitled UI loading-02, turning once every 3s. Held still under prefers-reduced-motion.
// Deliberately not exported: every export in this file becomes a CustomIconKey.
const SpinnerRotation = styled.g({
  transformBox: "fill-box",
  transformOrigin: "center",
  animation: `${spin} 3s linear infinite`,
  "@media (prefers-reduced-motion: reduce)": {
    animation: "none",
  },
});

export const spinner = (
  <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="none">
    <SpinnerRotation>
      <path
        d="M12 2v4m0 12v4M6 12H2m20 0h-4m1.078 7.078L16.25 16.25M19.078 5 16.25 7.828M4.922 19.078 7.75 16.25M4.922 5 7.75 7.828"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SpinnerRotation>
  </svg>
);

export const pendingProgress = (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M16 8C16 8.18381 15.9931 8.36607 15.9801 8.54669C15.9604 8.82208 15.7078 9.01507 15.434 8.97944L13.9491 8.78622C13.6752 8.75058 13.4845 8.49948 13.4955 8.22349C13.4985 8.14946 13.5 8.07495 13.5 8C13.5 7.92498 13.4985 7.85041 13.4955 7.77631C13.4844 7.50041 13.6751 7.24935 13.9489 7.21361L15.4339 7.01979C15.7077 6.98405 15.9605 7.17702 15.9801 7.45247C15.9931 7.63336 16 7.81591 16 8Z"
      fill="currentColor"
    />
    <path
      d="M13.9492 3.43564C14.1682 3.26732 14.4836 3.30757 14.638 3.53656C14.8411 3.83784 15.0243 4.15361 15.1856 4.48215C15.3073 4.72998 15.1849 5.0233 14.93 5.12915L13.546 5.70372C13.2908 5.80963 13.0002 5.68729 12.8715 5.44289C12.8031 5.31319 12.7297 5.18643 12.6515 5.06292C12.5037 4.82969 12.5427 4.51693 12.7615 4.34866L13.9492 3.43564Z"
      fill="currentColor"
    />
    <path
      d="M0 8C0 7.81594 0.00667022 7.63339 0.01934 7.45249C0.038633 7.17702 0.29131 6.98404 0.565131 7.01976L2.05109 7.21364C2.32491 7.24936 2.51555 7.50042 2.50448 7.77634C2.50151 7.85042 2.5 7.92499 2.5 8C2.5 8.07495 2.50151 8.14945 2.50448 8.22347C2.51554 8.49946 2.32478 8.75057 2.05087 8.7862L0.565024 8.97947C0.291241 9.01508 0.0386602 8.82208 0.0193491 8.54667C0.00668433 8.36604 0 8.18378 0 8Z"
      fill="currentColor"
    />
    <path
      d="M4.34867 12.7615C4.51693 12.5427 4.82969 12.5037 5.06292 12.6515C5.18643 12.7297 5.31319 12.8031 5.44289 12.8715C5.68729 13.0002 5.80963 13.2908 5.70372 13.546L5.12915 14.93C5.0233 15.1849 4.72998 15.3073 4.48215 15.1856C4.15361 15.0243 3.83784 14.8411 3.53656 14.638C3.30757 14.4836 3.26732 14.1682 3.43564 13.9492L4.34867 12.7615Z"
      fill="currentColor"
    />
    <path
      d="M12.5636 13.9492C12.7318 14.1682 12.6915 14.4835 12.4625 14.6379C12.1613 14.8411 11.8455 15.0243 11.517 15.1856C11.2691 15.3073 10.9758 15.1848 10.87 14.9298L10.296 13.5459C10.1903 13.2908 10.3126 13.0002 10.5569 12.8715C10.6867 12.8032 10.8134 12.7298 10.937 12.6516C11.1702 12.5038 11.4831 12.5428 11.6513 12.7618L12.5636 13.9492Z"
      fill="currentColor"
    />
    <path
      d="M2.45418 10.2959C2.70925 10.1902 2.99976 10.3126 3.12842 10.5569C3.19673 10.6866 3.27014 10.8133 3.34837 10.9369C3.49617 11.1702 3.45714 11.4831 3.23807 11.6513L2.04981 12.5637C1.83082 12.7319 1.51557 12.6915 1.3612 12.4626C1.15803 12.1613 0.974743 11.8456 0.813443 11.517C0.69174 11.2692 0.814226 10.9758 1.06932 10.87L2.45418 10.2959Z"
      fill="currentColor"
    />
    <path
      d="M5.70382 2.45409C5.80968 2.70918 5.68733 2.9998 5.44296 3.12851C5.31326 3.19682 5.18652 3.27022 5.06302 3.34846C4.82974 3.49623 4.51693 3.45726 4.34869 3.23829L3.4355 2.0498C3.26725 1.83083 3.30755 1.51551 3.5365 1.36113C3.83779 1.15797 4.15357 0.974709 4.4821 0.813413C4.72995 0.691734 5.02328 0.814125 5.1291 1.06914L5.70382 2.45409Z"
      fill="currentColor"
    />
    <path
      d="M8 0C8.18378 0 8.36604 0.00668433 8.54666 0.0193491C8.82208 0.0386602 9.01508 0.291241 8.97947 0.565024L8.7862 2.05087C8.75057 2.32478 8.49946 2.51554 8.22347 2.50448C8.14945 2.50151 8.07495 2.5 8 2.5C7.92499 2.5 7.85042 2.50151 7.77634 2.50448C7.50042 2.51555 7.24936 2.32491 7.21364 2.05109L7.01976 0.565131C6.98404 0.291311 7.17702 0.038633 7.45249 0.01934C7.63339 0.00667022 7.81594 0 8 0Z"
      fill="currentColor"
    />
    <path
      d="M3.23829 4.34869C3.45726 4.51693 3.49623 4.82974 3.34846 5.06302C3.27022 5.18652 3.19682 5.31326 3.12851 5.44296C2.9998 5.68733 2.70918 5.80968 2.45409 5.70382L1.06914 5.1291C0.814125 5.02328 0.691734 4.72995 0.813413 4.4821C0.974709 4.15357 1.15797 3.83779 1.36113 3.5365C1.51551 3.30755 1.83083 3.26725 2.0498 3.4355L3.23829 4.34869Z"
      fill="currentColor"
    />
    <path
      d="M10.87 1.06932C10.9758 0.814226 11.2692 0.69174 11.517 0.813443C11.8456 0.974743 12.1613 1.15803 12.4626 1.3612C12.6915 1.51557 12.7319 1.83082 12.5637 2.04981L11.6513 3.23807C11.4831 3.45714 11.1702 3.49617 10.9369 3.34837C10.8133 3.27014 10.6866 3.19673 10.5569 3.12842C10.3126 2.99976 10.1902 2.70925 10.2959 2.45418L10.87 1.06932Z"
      fill="currentColor"
    />
    <path
      d="M14.9298 10.87C15.1848 10.9758 15.3073 11.2691 15.1856 11.517C15.0243 11.8455 14.8411 12.1613 14.6379 12.4625C14.4835 12.6915 14.1682 12.7318 13.9492 12.5636L12.7618 11.6513C12.5428 11.4831 12.5038 11.1702 12.6516 10.937C12.7298 10.8134 12.8032 10.6867 12.8715 10.5569C13.0002 10.3126 13.2908 10.1903 13.5459 10.296L14.9298 10.87Z"
      fill="currentColor"
    />
    <path
      d="M7.21361 13.9489C7.24935 13.6751 7.50041 13.4844 7.77631 13.4955C7.85041 13.4985 7.92498 13.5 8 13.5C8.07495 13.5 8.14946 13.4985 8.22349 13.4955C8.49948 13.4845 8.75058 13.6752 8.78622 13.9491L8.97944 15.434C9.01507 15.7078 8.82208 15.9604 8.54669 15.9801C8.36607 15.9931 8.18381 16 8 16C7.81591 16 7.63336 15.9931 7.45247 15.9801C7.17702 15.9605 6.98405 15.7077 7.01979 15.4339L7.21361 13.9489Z"
      fill="currentColor"
    />
  </svg>
);

export const startingProgress = (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="8" cy="8" r="7" stroke="currentColor" strokeWidth="2" />
  </svg>
);

export const sortDescending = (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M3 7H21M3 12H15M3 17H9" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
  </svg>
);

export const sortAscending = (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M3 7H9M3 12H15M3 17H21" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
  </svg>
);

export const zoho = (
  <svg
    height="14"
    width="14"
    viewBox="5.02 56.7 290.5 182.54"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <title>Zoho CRM logo</title>
    <desc>Customer relationship management platform from Zoho</desc>
    <path
      d="m204.26,239.24c-24.19,0-46.98-9.37-64.17-26.38l-50.24-50.24c-5.85-5.85-9.06-13.63-9.03-21.9.03-8.27,3.28-16.03,9.16-21.84,12.02-11.88,31.53-11.82,43.48.13l46.01,46.01c5.39,5.39,14.18,5.41,19.59.05,2.65-2.62,4.11-6.11,4.12-9.84.01-3.72-1.43-7.23-4.07-9.86l-50.17-50.17c-14.02-13.87-32.64-21.51-52.38-21.45-20.14.05-38.94,7.96-52.94,22.27-14.02,14.33-21.52,33.32-21.12,53.47.79,40.11,34.09,72.75,74.23,72.75,7.18,0,14.27-1.02,21.08-3.03,4.5-1.33,9.23,1.24,10.55,5.74,1.33,4.5-1.24,9.23-5.74,10.56-8.37,2.47-17.08,3.73-25.89,3.73-49.33,0-90.25-40.11-91.22-89.41-.49-24.75,8.73-48.08,25.96-65.69,17.22-17.6,40.32-27.33,65.05-27.38,24.15-.06,47.14,9.31,64.39,26.38l50.22,50.22c5.85,5.86,9.07,13.64,9.05,21.92-.02,8.28-3.28,16.05-9.16,21.87-12.04,11.91-31.58,11.86-43.56-.12l-46.01-46.01c-5.37-5.37-14.12-5.39-19.52-.06-2.64,2.61-4.1,6.09-4.11,9.81-.01,3.71,1.43,7.21,4.05,9.83l50.19,50.2c13.97,13.82,32.52,21.45,52.2,21.45,40.9,0,74.21-33.27,74.25-74.17.02-19.82-7.7-38.48-21.74-52.54-14.04-14.06-32.69-21.8-52.51-21.8-6.32,0-12.59.79-18.65,2.36-.88.23-1.76.47-2.63.73-4.5,1.34-9.23-1.22-10.57-5.71-1.34-4.5,1.22-9.23,5.71-10.57,1.07-.32,2.15-.62,3.23-.9,7.44-1.92,15.15-2.9,22.9-2.9,24.36,0,47.28,9.51,64.53,26.78,17.25,17.27,26.74,40.2,26.71,64.56-.05,50.26-40.99,91.14-91.24,91.14Z"
      fill="currentColor"
    />
  </svg>
);

// Flat fills only: SVG ids are page-global, so every copy's url(#…) resolves to the first one on the
// page, and when that copy is hover-hidden (display:none) every other row's icon renders blank.
export const dynamics = (
  <svg height="14" width="14" viewBox="0 0 96 96" fill="none" xmlns="http://www.w3.org/2000/svg">
    <title>Microsoft Dynamics 365 logo</title>
    <desc>Customer relationship and business application platform from Microsoft</desc>
    <circle cx="42" cy="54" r="42" fill="#106EC1" />
    <path
      d="M95.6804 53.5695C95.8915 51.7423 96 49.8838 96 48C96 21.4903 74.5097 0 48 0C46.1162 0 44.2577 0.108519 42.4305 0.319647C41.0015 0.929827 40 2.34796 40 4V56H92C93.652 56 95.0702 54.9985 95.6804 53.5695Z"
      fill="#20ADEE"
    />
    <path d="M40 30H62C64.2091 30 66 31.7909 66 34V56H40V30Z" fill="#92EFFF" />
  </svg>
);
